module.exports = __webpack_public_path__ + "static/img/01.a019fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/190419/01.png
// module id = VxKF
// module chunks = 0